/**
 * Listas de referência usadas em vários formulários. Antes cada ecrã tinha a
 * sua cópia, incompleta e diferente das outras (a província era lista nos
 * clientes e texto livre nas definições; o banco "Outro" saía impresso nas
 * facturas). Onde o valor pode ser outro, o campo é texto com sugestões
 * (<datalist>), não uma lista fechada.
 */

/** Províncias de Moçambique (10 + a cidade de Maputo, com estatuto de província). */
export const PROVINCES = [
  'Maputo Cidade', 'Maputo Província', 'Gaza', 'Inhambane', 'Sofala', 'Manica', 'Tete', 'Zambézia', 'Nampula', 'Cabo Delgado', 'Niassa',
] as const;

/** Bancos comerciais a operar em Moçambique (sugestões — o campo aceita qualquer nome). */
export const BANKS = [
  'BCI', 'Millennium BIM', 'Standard Bank', 'Absa', 'Moza Banco', 'Nedbank', 'First Capital Bank', 'Access Bank', 'Ecobank',
  'FNB', 'Société Générale Moçambique', 'UBA Moçambique', 'BNI — Banco Nacional de Investimento', 'Letshego', 'Banco Mais', 'Socremo', 'Bayport',
] as const;

/** Carteiras móveis (sugestões — o número de telefone vai no campo do número). */
export const MOBILE_WALLETS = ['M-Pesa', 'e-Mola', 'mKesh'] as const;

/** Unidades de medida mais usadas (sugestões — até 15 caracteres, texto livre). */
export const UNITS = [
  'un', 'cx', 'pct', 'dz', 'par', 'conj', 'kit', 'rolo', 'saco', 'lata', 'garrafa', 'resma', 'palete', 'fardo',
  'kg', 'g', 't', 'l', 'ml', 'm', 'cm', 'km', 'm2', 'm3',
  'hora', 'dia', 'semana', 'mês', 'ano', 'noite', 'pessoa', 'serviço', 'viagem', 'kWh', 'licença',
] as const;

/** Prazos de pagamento propostos (em dias). Outro valor da ficha do cliente também aparece. */
export const PAYMENT_TERMS = [0, 7, 10, 15, 20, 30, 45, 60, 90, 120] as const;
